import React from "react";
import EventDetails from "./EventDetails";

function Step4Form({
  images,
  prevPage,
  ticketsData,
  eventData,
  isSubmitting = false,
}) {
  
  return (
    <div className="ListingDetailPage">
      <div className="space-y-11">
        <EventDetails
          images={images}
          eventData={eventData}
          ticketsData={ticketsData}
        />

        <div
          className="flex justify-end space-x-5"
          style={{
            marginBottom: "2rem",
            marginTop: "4rem",
            marginRight: "3rem",
          }}
        >
          <button
            type="button"
            onClick={prevPage}
            className="nc-Button relative h-auto inline-flex items-center justify-center rounded-lg transition-colors text-sm sm:text-base font-medium px-2 py-2 sm:px-4 ttnc-ButtonSecondary border bg-white border-neutral-200 text-neutral-700 dark:bg-neutral-900 dark:text-neutral-300 dark:border-neutral-700 hover:bg-neutral-100 dark:hover:bg-neutral-800    "
          >
            Retour
          </button>
          <button
            type="submit"
            disabled={isSubmitting}
            className="nc-Button relative h-auto inline-flex items-center justify-center rounded-lg transition-colors text-sm sm:text-base font-medium px-2 py-2 sm:px-4 ttnc-ButtonPrimary disabled:bg-opacity-70 disabled:cursor-not-allowed bg-primary-6000 hover:bg-primary-700 text-neutral-50"
          >
            {isSubmitting ? "Envoi en cours…" : "Enregistrer le ticket"}
          </button>
        </div>
      </div>
    </div>
  );
}
export default Step4Form;
